import { Button } from '@agms/ui'
import type { Lead } from '../../../lib/api'
import { SectionBody, SectionHeader } from './StageContextLayout'

export function ReadyToBuildContext({ onNavigate }: { lead: Lead; onNavigate: (p: string) => void }) {
  return (
    <>
      <SectionHeader color="#ccfbf1">
        <h3 style={{ fontSize: '15px', fontWeight: 600, color: '#0f766e' }}>Ready to Build</h3>
      </SectionHeader>
      <SectionBody>
        <p style={{ fontSize: '14px', color: '#0f766e', marginBottom: '12px' }}>
          Application approved by Fiserv. Deployment tasks are being processed — terminal provisioning,
          gateway setup, and service activation are running independently.
        </p>
        <Button variant="secondary" onClick={() => onNavigate('/pipeline')}>
          View Deployment Center
        </Button>
      </SectionBody>
    </>
  )
}
